import { PackageTheme } from '~app/styles/pricing/types';
import { packageColors } from '~app/styles/theme';
import { Packages } from '~shared/constants/pricing';

const grow2529Theme: PackageTheme = {
  [Packages.AdvantageAnnual]: {
    primary: packageColors.advantageAnnual,
  },
  [Packages.Basic]: {
    primary: packageColors.basic,
  },
  [Packages.Enterprise]: {
    primary: packageColors.enterprise,
  },
  [Packages.PremierAnnual]: {
    primary: packageColors.premierAnnual,
  },
  [Packages.StarterMonthly]: {
    primary: packageColors.starterMonthly,
  },
  [Packages.StarterAnnual]: {
    primary: packageColors.starterAnnual,
  },
  [Packages.StandardAnnual]: {
    primary: packageColors.starterAnnual,
  },
  [Packages.StandardMonthly]: {
    primary: packageColors.starterMonthly,
  },
  [Packages.TeamAdvantage]: {
    primary: packageColors.teamAdvantage,
  },
  [Packages.TeamPremier]: {
    primary: packageColors.teamPremier,
  },
  [Packages.Flex]: {
    primary: packageColors.standardMonthly,
  },
  [Packages.FormsAnnual]: {
    primary: packageColors.forms,
  },
  [Packages.FormsMonthly]: {
    primary: packageColors.forms,
  },
};

export default grow2529Theme;
